import script from "./terminals.vue?vue&type=script&setup=true&lang=js"
export * from "./terminals.vue?vue&type=script&setup=true&lang=js"

import "./terminals.vue?vue&type=style&index=0&id=b1b40afe&scoped=true&lang=css"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1b40afe"]])

export default __exports__